import React, {Component} from 'react';
import Aux from '../../hoc/Aux/Aux'
import Input from '../../components/UI/Input/Input';
import CallToAction from '../../components/CallToAction/CallToAction';
import {checkValidity} from "../../shared/utility";
import axios from '../../axios-base';
import {cleanLocationProp} from "../../shared/utility";
import {Col, Row, Button, Form, FormGroup} from 'reactstrap';
import {connect} from 'react-redux';
import MediaUpload from '../MediaUpload/MediaUpload'
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";

class SignUp extends Component {

    state = {
        projectForm: {},
        mediaObjects: [],
        formIsValid: false,
        projectId: null,
        cta: null
    };

    onUploadHandler = (uploadUrl) => {
        this.setState(previousState => ({
            // Incoming urls from MediaUpload.js
            mediaObjects: uploadUrl
        }))
    };

    // TODO: Wie wirken sich die zahlreichen onChange-Events auf die Peformance aus? Ist es vlt. besser onSubmit zu nutzen?
    onChangeHandler = (event, inputIdentifier) => {
        const updatedProjectForm = {
            ...this.state.projectForm
        };

        // Deep clone
        const updatedFormElement = {
            ...updatedProjectForm[inputIdentifier]
        };

        /**
         *  Check if form element is of type file, and if so set selectedFile state AND value
         *  else only set value
         */
        if (updatedFormElement.elementType === 'file' && !updatedFormElement.elementConfig.multiple) {
            updatedFormElement.selectedFile = event.target.files[0];
            updatedFormElement.value = event.target.value;
        } else if (updatedFormElement.elementType === 'file' && updatedFormElement.elementConfig.multiple) {
            updatedFormElement.selectedFiles = event.target.files;
            updatedFormElement.value = event.target.value;
        } else if (updatedFormElement.elementType === 'checkbox') {
            updatedFormElement.value = event.target.checked;
        } else {
            updatedFormElement.value = event.target.value;
        }
        updatedFormElement.valid = checkValidity(updatedFormElement.value, updatedFormElement.validation);
        updatedFormElement.touched = true;
        updatedProjectForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedProjectForm) {
            formIsValid = updatedProjectForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({projectForm: updatedProjectForm, formIsValid: formIsValid});
    };

    onSubmitHandler = (event) => {
        event.preventDefault();
        // project-Objekt fuer axios POST bauen
        const fd = new FormData();
        const projectFormData = {};

        // Iterate through React state form and set values depending on elementType (i.e. 'file')
        for (let formElementIdentifier in this.state.projectForm) {

            if (this.state.projectForm[formElementIdentifier].elementType === 'file' && !this.state.projectForm[formElementIdentifier].elementConfig.multiple) {
                projectFormData[formElementIdentifier] = this.state.projectForm[formElementIdentifier].selectedFile;
                fd.append(formElementIdentifier, projectFormData[formElementIdentifier]);
            } else if (this.state.projectForm[formElementIdentifier].elementType === 'file' && this.state.projectForm[formElementIdentifier].elementConfig.multiple) {
                for (let [index, file] in Object.entries(this.state.projectForm[formElementIdentifier].selectedFiles)) {
                    fd.append(formElementIdentifier, this.state.projectForm[formElementIdentifier].selectedFiles[index]);
                    console.log(file);
                }
            } else {
                projectFormData[formElementIdentifier] = this.state.projectForm[formElementIdentifier].value;
                fd.append(formElementIdentifier, projectFormData[formElementIdentifier]);
            }

        }

        //Append image urls to the signup form
        fd.append("projectGallery", JSON.stringify(this.state.mediaObjects));


        // if user is authenticated patch project
        if (this.props.isAuthenticated) {
            const config = {
                headers: {'Authorization': "bearer " + this.props.token}
            };

            axios.patch(
                    // Todo: Echte Projekt-ID waehlen
                    '/projects/' + this.state.projectId, fd,
                    config
                )
                .then((response) => {
                    // Todo: Erfolgsnachricht anzeigen statt auf Startseite umzuleiten
                    this.setState({systemMessage: response, signUpSuccess: true});
                    this.props.history.push('/vielen-dank');
                })
                .catch(error => {
                    console.log(error);
                });
        // if user is NOT authenticated post new project
        } else {
            axios.post('/projects', fd)
                .then((response) => {
                    // Todo: Erfolgsnachricht anzeigen statt auf Startseite umzuleiten
                    this.props.history.push('/vielen-dank');

                })
                .catch(error => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {

        axios.get('/cta/',{
            params: {
                page: cleanLocationProp(this.props.location.pathname)
            }})
            .then(response => {
                    this.setState({cta: response.data[0]});
            })
            .catch(error => {
                this.setState({error: true});
            });

        axios.get('/options/')
            .then(response => {
                this.setState({projectForm: response.data[0].projectForm});
            })
            .catch(error => {
                this.setState({error: true});
            });

        // Pre-fill form data for authenticated users with their respective project
        if (this.props.isAuthenticated) {
            const config = {
                headers: {'Authorization': "bearer " + this.props.token}
            };

            // Get user id from redux store dependent on authenticated user
            axios.get(
                    '/users/' + this.props.userId,
                    config
                )
                .then(response => {
                    const sampleData1 = { value: response.data.project.contestantAnswer1, valid: true };
                    const sampleData2 = { value: response.data.project.contestantAnswer2, valid: true };
                    const sampleData3 = { value: response.data.project.contestantZipcode, valid: true };
                    const sampleData4 = { value: response.data.project.contestantStreet, valid: true };
                    const sampleData5 = { value: response.data.project.contestantCity, valid: true };
                    const sampleData6 = { value: response.data.project.contestantName, valid: true };
                    const sampleData7 = { value: response.data.project.projectTitle, valid: true };
                    const sampleData8 = { value: response.data.salutation, valid: true };
                    const sampleData9 = { value: response.data.telephone, valid: true };
                    const sampleData10 = { value: response.data.firstname, valid: true };
                    const sampleData11 = { value: response.data.lastname, valid: true };
                    // Todo: Iterate through state in a more elegant way
                    this.setState(prevState => ({
                        projectForm: {
                            ...prevState.projectForm,
                            contestantAnswer1: { ...prevState.projectForm.contestantAnswer1, ...sampleData1 },
                            contestantAnswer2: { ...prevState.projectForm.contestantAnswer2, ...sampleData2 },
                            contestantZipcode: { ...prevState.projectForm.contestantZipcode, ...sampleData3 },
                            contestantStreet:  { ...prevState.projectForm.contestantStreet, ...sampleData4 },
                            contestantCity:    { ...prevState.projectForm.contestantCity, ...sampleData5 },
                            contestantName:    { ...prevState.projectForm.contestantName, ...sampleData6 },
                            projectTitle:      { ...prevState.projectForm.projectTitle, ...sampleData7 },
                            contactSalutation: { ...prevState.projectForm.contactSalutation, ...sampleData8 },
                            contactTelephone:  { ...prevState.projectForm.contactTelephone, ...sampleData9 },
                            contactFirstname:  { ...prevState.projectForm.contactFirstname, ...sampleData10 },
                            contactLastname:   { ...prevState.projectForm.contactLastname, ...sampleData11 },
                            contactEmail:      { ...prevState.projectForm.contactEmail, valid: true },
                            contactPassword:   { ...prevState.projectForm.contactPassword, valid: true }
                        },
                        ...prevState.formIsValid, formIsValid: true,
                        ...prevState.projectId, projectId: response.data.project._id
                    }));
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }

    render() {

        const formElementsArray = [];

        for (let key in this.state.projectForm) {
            if (this.props.isAuthenticated) {
                if (this.state.projectForm[key].ifAuth === true) {
                    formElementsArray.push({
                        id: key, // Left part of projectForm objects (i.e. projectTitle)
                        config: this.state.projectForm[key] // Right part of projectForm objects (i.e. elementConfig{...})
                    });
                }
            } else {
                formElementsArray.push({
                    id: key, // Left part of projectForm objects (i.e. projectTitle)
                    config: this.state.projectForm[key] // Right part of projectForm objects (i.e. elementConfig{...})
                });
            }
        }

        let button = null;

        if(this.state.formIsValid) {
            button = (
                <Button color="primary">
                    {this.props.isAuthenticated ? 'Jetzt speichern' : 'Jetzt absenden'}
                </Button>
            );
        } else {
            button = (
                <Button color="primary" disabled>
                    Bitte prüfen Sie Ihre Angaben
                </Button>
            );
        }

        let form = (
            <Form onSubmit={this.onSubmitHandler}>
                <FormGroup row>
                    <Col sm={{size: 12}}>
                        <MediaUpload onUploadHandler={this.onUploadHandler}/>
                    </Col>
                </FormGroup>

                <Row>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            name={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            changed={(event) => this.onChangeHandler(event, formElement.id)}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            errorMessage={formElement.config.errorMessage}
                            invalid={!formElement.config.valid}/>
                    ))}
                </Row>

                <FormGroup row>
                    <Col sm={{size: 12}}>
                        {button}
                    </Col>
                </FormGroup>

            </Form>
        );

        if (this.state.loading) {
            // Todo: Insert placeholder SVG
            form = "..."
        }

        let cta = <CallToActionPlaceholder/>;

        if(this.state.cta){
            cta = <CallToAction
                headline={this.state.cta.headline}
                copy={this.state.cta.copy}
                buttonText={this.state.cta.buttonText}
                buttonColor={this.state.cta.buttonColor}
                linkUrl={this.state.cta.linkUrl}
                outline={this.state.cta.outline} />
        }

        return (
            <Aux>
                <Row className="mb-3">
                    <Col xs="12" lg="9" className="py-3">
                        {cta}
                    </Col>
                    <Col xs="12" lg="3" className="p-3">
                        <h3>Unser Bewerbungsservice</h3>
                        <a className="h1" href="tel:+4922167774683">0221 677 746 83</a>
                        <p>Montag bis Freitag <br/>9 Uhr bis 17 Uhr</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {form}
                    </Col>
                </Row>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        userId: state.auth.userId,
        token: state.auth.token
    }
};

export default connect(mapStateToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/containers/SignUp/SignUp.js